module.exports = __webpack_public_path__ + "static/img/banner1-Cz5FJ_ZW.a983458.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/banner1-Cz5FJ_ZW.png
// module id = +G9Q
// module chunks = 16